import AuthExperience from '../sections/auth/AuthExperience';

export default function Signup() {
  return <AuthExperience mode="signup" />;
}
